let accordion = require('./accordion');
require("./memberRegistrationView");

function initialize() {
    accordion.bindClickHandlers();

    $("input[name='member_has_card']").change(function () {
        $('.register-check-card-form').parsley().destroy();

        if (this.value === 'true') {
            showCheckMembershipCardBlock();
        } else if (this.value === 'false') {
            hideCheckMembershipCardBlock();
        }

        $('.register-check-card-form').parsley();

    });

    $('.register-check-card-button').on('click', onClick);
}

const isFormDataValid = () =>
    $('.register-check-card-form').parsley('validate').whenValidate()

async function onClick(event) {
    isFormDataValid().done(async () => {
        event.preventDefault();

        const siteKeyEl = document.getElementById("site-key")

        if (siteKeyEl) {
            const siteKey = siteKeyEl.value;

            let action = 'CHECK_MEMBERSHIP_CARD';
            document.getElementById("reCaptchaAction").value = action;
            document.getElementById("reCaptchaToken").value =
                await window.grecaptcha.enterprise.execute(siteKey, {action: action});

        }
        document.getElementById('register-check-card-form').submit();
    });
}

function showCheckMembershipCardBlock() {
    $('.register-check-card__membership-number--hidden')
        .removeClass('register-check-card__membership-number--hidden');
    $('#member-card-number').attr('data-parsley-required', true);
    $('#member-card-number').attr('data-parsley-registercheckcard');

}

function hideCheckMembershipCardBlock() {
    $('.register-check-card__membership-number')
        .addClass('register-check-card__membership-number--hidden');
    $('#member-card-number').removeAttr('data-parsley-required', false);
    $('#member-card-number').removeAttr('data-parsley-registercheckcard');
}

module.exports = {
    initialize: initialize,
};
